import { render, staticRenderFns } from "./ReservedPromotion.vue?vue&type=template&id=0ceaad66&scoped=true"
import script from "./ReservedPromotion.vue?vue&type=script&lang=js"
export * from "./ReservedPromotion.vue?vue&type=script&lang=js"
import style0 from "./ReservedPromotion.vue?vue&type=style&index=0&id=0ceaad66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceaad66",
  null
  
)

export default component.exports